import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { EMPTY } from 'rxjs';
import {catchError, map, switchMap} from 'rxjs/operators';

import * as fromApp from '../../store';
import { SetTableLoading } from '../actions/layout.actions';
import { AdminProjectsService } from './../../modules/admin-of-project/services/admin-projects.service';
import * as AdminProjectsActiveActions from './../actions/admin-projects-active.actions';
import { ForceHide } from './../actions/layout.actions';

@Injectable()
export class AdminProjectsActiveEffects {

  constructor(
    private actions$: Actions,
    private adminProjectsService: AdminProjectsService,
    private store: Store<fromApp.AppState>
  ) { }

    scrollAdminProjectActiveTable$ = createEffect(() => this.actions$.pipe(
      ofType(
        AdminProjectsActiveActions.ScrollAdminProjectsActive
      ),
      switchMap((action) => {
        this.store.dispatch(SetTableLoading({loading: true}));
        return this.adminProjectsService
          .getAdminTableData(action.page, action.size, action.sort)
          .pipe(
            map(data => {
          this.store.dispatch(SetTableLoading({loading: false}));
              return AdminProjectsActiveActions.LoadAdminProjectsActiveDataSuccessAction({
                adminProjectActiveTableItems: data
              });
            }),
            catchError((err, caught) => {
               return EMPTY;
             })
          );
      }))
    );

    sortAdminProjectActiveTable$ = createEffect(() => this.actions$.pipe(
      ofType(
        AdminProjectsActiveActions.SortAdminProjectsActive
      ),
      switchMap((action) => {
        return this.adminProjectsService
          .getAdminTableData(action.page, action.size, action.sort)
          .pipe(
            map(data => {
              return AdminProjectsActiveActions.LoadAdminProjectsActiveDataSuccessAction({
                adminProjectActiveTableItems: data
              });
            }),
            catchError((err, caught) => {
               return EMPTY;
             })
          );
      }))
    );

    searchAdminProjectActiveTable$ = createEffect(() => this.actions$.pipe(
      ofType(
        AdminProjectsActiveActions.SearchAdminProjectsActive
      ),
      switchMap((action) => {
        this.store.dispatch(SetTableLoading({loading: true}));
        this.store.dispatch(ForceHide({forceHide: true}));
        return this.adminProjectsService
          .searchProjects(action.page, action.size, action.sort, null, null, action.search)
          .pipe(
            map(data => {
            this.store.dispatch(ForceHide({forceHide: false}));
             this.store.dispatch(SetTableLoading({loading: false}));
              return AdminProjectsActiveActions.LoadAdminProjectsActiveDataSuccessAction({
                adminProjectActiveTableItems: data
              });
            }),
            catchError((err, caught) => {
               return EMPTY;
             })
          );
      }))
    );

    searchSortAdminProjectActiveTable$ = createEffect(() => this.actions$.pipe(
      ofType(
        AdminProjectsActiveActions.SearchSortAdminProjectsActive
      ),
      switchMap((action) => {
        return this.adminProjectsService
          .searchProjects(action.page, action.size, action.sort, null, null, action.search)
          .pipe(
            map(data => {
              return AdminProjectsActiveActions.LoadAdminProjectsActiveDataSuccessAction({
                adminProjectActiveTableItems: data
              });
            }),
            catchError((err, caught) => {
               return EMPTY;
             })
          );
      }))
    );

    searchScrollAdminProjectActiveTable$ = createEffect(() => this.actions$.pipe(
      ofType(
        AdminProjectsActiveActions.SearchScrollAdminProjectsActive
      ),
      switchMap((action) => {
        this.store.dispatch(SetTableLoading({loading: true}));
        return this.adminProjectsService
          .searchProjects(action.page, action.size, action.sort, null, null, action.search)
          .pipe(
            map(data => {
          this.store.dispatch(SetTableLoading({loading: false}));
          return AdminProjectsActiveActions.LoadAdminProjectsActiveDataSuccessAction({
            adminProjectActiveTableItems: data
          });
            }),
            catchError((err, caught) => {
               return EMPTY;
             })
          );
      }))
    );

    loadAdminProjectActiveTable$ = createEffect(() => this.actions$.pipe(
        ofType(AdminProjectsActiveActions.LoadAdminProjectsActive),
        switchMap((action) => {
            this.store.dispatch(SetTableLoading({loading: true}));
            this.store.dispatch(ForceHide({forceHide: true}));
            return this.adminProjectsService
                .getAdminTableData(action.page, action.size, action.sort)
                .pipe(
                    map(data => {
                        this.store.dispatch(ForceHide({forceHide: false}));
                        this.store.dispatch(SetTableLoading({loading: false}));
                        return AdminProjectsActiveActions.LoadAdminProjectsActiveDataSuccessAction({
                            adminProjectActiveTableItems: data
                        });
                    }),
                    catchError((err, caught) => {
                        return EMPTY;
                    })
                );
        }))
    );
}
